import React, { Component } from 'react';
import PropTypes from 'prop-types';

import TabToggle from '../../TabToggle/TabToggle';
import FlipCardContainer from '../../FlipCard/FlipCardContainer';
import FlipCard from '../../FlipCard/FlipCard';
import AreaOverview from '../AreaOverview/AreaOverview';
import AreaDetails from '../AreaDetails/AreaDetails';
import AreaWorkforce from '../AreaWorkforce/AreaWorkforce';
import svgInline from '../../SvgInline/SvgInline';
import { ViewerPrimaryColorUserStyle } from '../../UserCustomization';
import AreaInformationHeader from './AreaInformationHeader';
import PropertyDetailContact from '../../PropertyDetail/PropertyDetailContact/PropertyDetailContact';

import closeIcon from '../../../shared/assets/icon-close.svg';

import './AreaInformationContainer.css';

export class AreaInformationContainerComponent extends Component {
  constructor(props) {
    super(props);
    this.state = {
      detailMenuLength: 0,
      showWorkforceData: false,
    };
    this.handleToggleClick = this.handleToggleClick.bind(this);
    this.setDetailMenuLength = this.setDetailMenuLength.bind(this);
    this.handleWorkforceClick = this.handleWorkforceClick.bind(this);
  }

  setDetailMenuLength(menuLength) {
    this.setState({ detailMenuLength: menuLength });
  }

  handleToggleClick(tab) {
    const { routeToSubTab, layer, area } = this.props;
    routeToSubTab(layer, area._id, tab === 'details' ? `/details${window.location.search}` : window.location.search);
  }

  handleWorkforceClick({ cancel = false } = {}) {
    this.setState({ showWorkforceData: !cancel });
  }

  render() {
    const { handleClick,
      handleModalClick,
      sort,
      overview,
      area,
      addFilter,
      organizationId,
      organizationContact,
      layer,
      subTab,
      showShareModal,
      showSlideshow,
      showDownloadModal,
      showSpecialDownloadModal,
      showModal,
      detailInfoToShow,
      viewer,
    } = this.props;
    const { showWorkforceData } = this.state;

    const flip = subTab === 'details';
    const hasWorkforceData = !!overview.details.laborForceUrls;

    return (
      <div className="detail-wrapper">
        <ViewerPrimaryColorUserStyle domStyle="backgroundColor">
          <a
            className="close-btn"
            tabIndex="0"
            onClick={() => { handleClick(layer, null); }}
          >
            {svgInline(closeIcon)}
            CLOSE
          </a>
        </ViewerPrimaryColorUserStyle>
        <div className="building-detail">
          <AreaInformationHeader
            handleModalClick={handleModalClick}
            handleWorkforceClick={this.handleWorkforceClick}
            area={area}
            overview={overview}
            layer={layer}
            organizationId={organizationId}
            showShareModal={showShareModal}
            showSlideshow={showSlideshow}
            showDownloadModal={showDownloadModal}
            showSpecialDownloadModal={showSpecialDownloadModal}
            showModal={showModal}
            viewer={viewer}
          />
          {(showWorkforceData && hasWorkforceData)
            ? (
              <AreaWorkforce
                occupationUrl={overview.details.laborForceUrls.occupationUrl}
                industryUrl={overview.details.laborForceUrls.industryUrl}
                onCancel={() => {
                  this.handleWorkforceClick({ cancel: true });
                }}
              />
            ) : (
              <div className="detail-content">
                <div className="detail-toggle">
                  <TabToggle
                    handleClick={this.handleToggleClick}
                    name="detailToggle"
                    checked={flip}
                    leftTab="Overview"
                    rightTab="Details"
                    subTab={subTab === undefined ? 'overview' : 'details'}
                    detailMenuLength={this.state.detailMenuLength}
                    shouldShowRightTab={this.state.detailMenuLength > 0}
                  />

                  <div className="to-properties-container">
                    {['buildings', 'sites'].map(propertyType => (
                    ((viewer.visibleSections.buildings && overview.details.buildings > 0 && propertyType === 'buildings') ||
                    (viewer.visibleSections.sites && overview.details.sites > 0 && propertyType === 'sites')) &&
                    <ViewerPrimaryColorUserStyle key={propertyType} domStyle="backgroundColor">
                      <a
                        key={propertyType}
                        className="btn"
                        tabIndex="0"
                        onClick={() => {
                          const layerFilters = {
                            communities: 'community',
                            states: 'state',
                            regions: 'region',
                            counties: 'county',
                          };
                          let value;
                          if (layer === 'states') {
                            value = [area.state_cd];
                          } else {
                            value = [{ name: area.name, id: area.intid, esriid: area.id }];
                          }
                          const newFilterValue = new Map().set(layerFilters[layer], value);
                          addFilter(
                            propertyType,
                            newFilterValue,
                            sort[propertyType],
                            organizationId,
                          );
                        }}
                      >
                        {propertyType}
                      </a>
                    </ViewerPrimaryColorUserStyle>
                    ))}
                  </div>

                </div>
                <FlipCardContainer flip={flip} transform>
                  <FlipCard side="front">
                    <AreaOverview
                      area={area}
                      overview={overview}
                      layer={layer}
                    />
                  </FlipCard>
                  <FlipCard side="back">
                    <AreaDetails
                      detailMenuLength={this.state.detailMenuLength}
                      setDetailMenuLength={this.setDetailMenuLength}
                      overview={overview}
                      detailInfoToShow={detailInfoToShow}
                    />
                  </FlipCard>
                </FlipCardContainer>
              </div>
            )
          }
          <PropertyDetailContact
            className="detail-footer"
            contact={organizationContact}
            viewer={viewer}
          />
        </div>
      </div>
    );
  }
}

AreaInformationContainerComponent.propTypes = {
  handleClick: PropTypes.func,
  handleModalClick: PropTypes.func,
  addFilter: PropTypes.func,
  sort: PropTypes.shape({
    buildings: PropTypes.arrayOf(PropTypes.oneOfType([PropTypes.number, PropTypes.string])),
    sites: PropTypes.arrayOf(PropTypes.oneOfType([PropTypes.number, PropTypes.string])),
  }),
  area: PropTypes.shape({
    name: PropTypes.string,
    polygon: PropTypes.object,
  }),
  overview: PropTypes.object,
  organizationId: PropTypes.string,
  layer: PropTypes.string.isRequired,
  subTab: PropTypes.string,
  routeToSubTab: PropTypes.func,
  showShareModal: PropTypes.func,
  showSlideshow: PropTypes.func.isRequired,
  showDownloadModal: PropTypes.func.isRequired,
  showSpecialDownloadModal: PropTypes.func.isRequired,
  showModal: PropTypes.func.isRequired,
  detailInfoToShow: PropTypes.arrayOf(PropTypes.string),
  organizationContact: PropTypes.object,
  viewer: PropTypes.object.isRequired,
};

export default AreaInformationContainerComponent;



// WEBPACK FOOTER //
// ./src/components/Areas/AreaInformationContainer/AreaInformationContainer.js